import {
  GET_PROJECT_REQUEST, GET_PROJECT_SUCCESS, GET_PROJECT_FAILURE,
  GET_PROJECT_REQUEST_ADMIN2, GET_PROJECT_SUCCESS_ADMIN2, GET_PROJECT_FAILURE_ADMIN2,
  ACCEPT_PROJECT_REQUEST, ACCEPT_PROJECT_SUCCESS, ACCEPT_PROJECT_FAILURE,
  REJECT_PROJECT_REQUEST, REJECT_PROJECT_SUCCESS, REJECT_PROJECT_FAILURE,
  GET_PUBLISHED_REQUEST, GET_PUBLISHED_SUCCESS, GET_PUBLISHED_FAILURE,

} from '../Constants/ActionTypes';
import { toast } from "react-toastify";
import * as API from '../API/api.js';

export const getProjectInfo = (token) => async dispatch => {
  try {
    dispatch({ type: GET_PROJECT_REQUEST });
    const data = await API.getAllProjectInfo(token);

    if (data.data.success === true) {
      // toast("Project Uploaded Successfully")
      // console.log("admin-1",data.data)
      dispatch({ type: GET_PROJECT_SUCCESS, payload: data.data.data });
      // navigate('/')
    }
  } catch (error) {
    // toast('DATA NOT DISPATCHED');
    dispatch({ type: GET_PROJECT_FAILURE });
  }
};

export const getProjectInfoAdmin2 = (token) => async dispatch => {
  try {
    dispatch({ type: GET_PROJECT_REQUEST_ADMIN2 });
    const data = await API.getAllProjectInfoAdmin2(token);

    if (data.data.success === true) {
      // toast("Project Uploaded Successfully")
      // console.log("admin-2",data.data.data)
      dispatch({ type: GET_PROJECT_SUCCESS_ADMIN2, payload: data.data.data });
      // navigate('/')
    }
  } catch (error) {
    console.log(error);
    toast('DATA NOT DISPATCHED');
    dispatch({ type: GET_PROJECT_FAILURE_ADMIN2 });
  }
};

export const getProjectInfoAdmin2Return = async(token) => {
  try {
    const data = await API.getAllProjectInfoAdmin2(token);

    if (data.data.success === true) {
      // toast("Project Uploaded Successfully")
      // console.log("admin-2",data.data.data)
      return data.data.data;
      // navigate('/')
    }
  } catch (error) {
    console.log(error);
    toast('DATA NOT DISPATCHED');
  }
};

export const getPublishedPapers = (token) => async dispatch => {
  try {
    dispatch({ type: GET_PUBLISHED_REQUEST });
    const data = await API.publishedPapers(token);

    if (data.data.success === true) {
      // toast("Project Uploaded Successfully")
      // console.log("admin-1",data.data)
      dispatch({ type: GET_PUBLISHED_SUCCESS, payload: data.data.data });
      // navigate('/')
    }
  } catch (error) {
    // toast('DATA NOT DISPATCHED');
    dispatch({ type: GET_PUBLISHED_FAILURE });
  }
};

export const acceptProject = (value, token) => async dispatch => {
  try {
    dispatch({ type: ACCEPT_PROJECT_REQUEST });
    console.log('value: ', value);

    const data = await API.acceptProject(value, token);
    if (data) {
      toast("PROJECT ACCEPTED")
      dispatch({ type: ACCEPT_PROJECT_SUCCESS, payload: data.data.data });
    }
  } catch (error) {
    toast('PLEASE TRY AGAIN');
    dispatch({ type: ACCEPT_PROJECT_FAILURE });
  }
};

export const rejectProject = (value, token) => async dispatch => {
  try {
    dispatch({ type: REJECT_PROJECT_REQUEST });
    const data = await API.rejectProject(value, token);

    if (data) {
      toast("PROJECT REJECTED")
      dispatch({ type: REJECT_PROJECT_SUCCESS, payload: data.data.data });
      // navigate('/')
    }
  } catch (error) {
    toast('PLEASE TRY AGAIN');
    dispatch({ type: REJECT_PROJECT_FAILURE });
  }
};